export default function (items, btnRecipeId, recipeDeleteId) {
	let samerecipesave = localStorage.getItem("samerecipesave");
	if(samerecipesave) {
		samerecipesave = JSON.parse(samerecipesave);
		if(samerecipesave.ids.includes(btnRecipeId)) {
			if(items.length > 0) {
				samerecipesave.ids = samerecipesave.ids.filter(item => item != btnRecipeId);
				[].forEach.call(items, function(v,i) {
					const delId = v.getAttribute('id');
					samerecipesave.ids = samerecipesave.ids.filter(item => item != delId);
				})
				const saveDelJson = JSON.stringify(samerecipesave);
				localStorage.setItem("samerecipesave", saveDelJson);
			}
		}
	}
	//ブックマークを削除
	let bookmark = localStorage.getItem("bookmark");
	if(bookmark) {
		bookmark = JSON.parse(bookmark);
		if(bookmark.ids.includes(btnRecipeId)) {
			bookmark.ids = bookmark.ids.filter(item => item != btnRecipeId);
			if(items.length > 0) {
				[].forEach.call(items, function(v,i) {
					const delId = v.getAttribute('id');
					bookmark.ids = bookmark.ids.filter(item => item != delId);
				})
			}
		}
		if(bookmark.ids.includes(recipeDeleteId)) {
			bookmark.ids = bookmark.ids.filter(item => item != recipeDeleteId);
		}
		const saveJson = JSON.stringify(bookmark);
		localStorage.setItem("bookmark", saveJson);
	}
}
